// extracted by mini-css-extract-plugin
module.exports = {"responsive":"OxyijZdvSSCrtPa99cOPp"};